<template>
    <main-layout>
        <template #header>
            <main-header :title="'프린터 시리즈' | translate" />
        </template>
        <template #toolbar>
            <div style="width: 500px">
                <search-bar
                    :placeholder="'id, 제조사, 대표모델, 지원모델만 검색이 가능합니다.' | translate"
                    v-model="searchKeyword" />
            </div>
        </template>
        <template #body>
            <v-tabs v-model="tabNumber">
                <v-tab :key="'V1'">V1</v-tab>
                <v-tab :key="'V2'">V2</v-tab>
            </v-tabs>
            <v-tabs-items style="width: 100%; height: 100%">
                <no-library-bagic-table :table-body-data="filteredItems"
                                        :tab-number="tabNumber"
                                        @complete-button-click="completeButtonClick"
                                        @sort-option-change="sortOptionChange"
                />
            </v-tabs-items>

            <div class="loading_wrap" v-show="isLoading">
                <div class="loading"></div>
                <div class="loading"></div>
                <div class="loading"></div>
            </div>
        </template>

    </main-layout>
</template>

<script>
/**
 * 기존에 있던(MonitoringPrinterSeries.vue)
 * 프린트 시리즈대신 새로운 프린트 시리즈 컴포넌트를 만들었습니다
 * 테이블은 매출확인이나 거래처관리 부분에서 태그 테이블 구현한것을 가져와서 사용했습니다.
 * 그리고 검색요청은 없고 프론트에서 직접 처리했습니다.
 * Tab에따라서 테이블의 데이터가 바뀌고 테이블 레이아웃은 그대로입니다.
 * V1과 V2의 update와 조회부분은 동시에 수행해야됩니다.
 */
import MainLayout from "@/components/common/layout/MainLayout";
import MainHeader from "@/components/common/layout/MainHeader";
import SearchBar from "@/components/input/SearchBar";
import NoLibraryBagicTable from "@/views/monitoring/printerSeries/NoLibraryBagicTable";
import{PATH} from "@/constants";

export default {
    name: "NewMonitoringPrinterSeries",
    components: {
        MainLayout,
        MainHeader,
        SearchBar,
        NoLibraryBagicTable
    },
    data() {
        return{
            searchKeyword:undefined,
            isLoading:false,//로딩바를 다루는데 사용합니다.
            tableBodyData:{//V1과 V2의 데이터는 항상 갖고있습니다.
                versionOne:[],
                versionTwo:[]
            },
            tabNumber: 0,//V1일때는 0 V2일때는 1 로 구분합니다.
        }
    },
    watch :{

        /**
         * tab의 값이 바뀌면 V1 V2 상황에 맞겠음 요청을 보낸다
         */
        tabNumber:{
            handler(newValue) {
                this.tableDataLoad(newValue)
            }
        }
    },
    computed: {
        /**
         * 검색키워드 작성하고 enter를 누를때 동작합니다.
         * 기본적으로 키워드랑 일치하는 데이터를 찾고
         * 조건은 아래와 같습니다
         * 1. supportedPrinterSeriesId(ID)
         * 2. manufactorName(제조사)
         * 3. seriesName(대표 모델)
         * 4. supportModel(지원 모델)
         * @returns {{versionOne: *[], versionTwo: *[]}}
         */
        filteredItems() {
            const sameSearchKeywordCheck = (data) => {
                const sameId = data.supportedPrinterSeriesId.toString().includes(this.searchKeyword)
                const sameManufactor = data.manufactorName.toString().includes(this.searchKeyword)
                const sameSeries = data.seriesName.toString().includes(this.searchKeyword)
                const sameSupportModel = data.supportModel.toString().includes(this.searchKeyword)
                return sameId || sameManufactor || sameSeries || sameSupportModel
            }
            const versionOne = this.tableBodyData.versionOne.filter(e => {
                return !this.searchKeyword ? true
                    : sameSearchKeywordCheck(e)
            })
            const versionTwo = this.tableBodyData.versionTwo.filter(e => {
                return !this.searchKeyword ? true
                    : sameSearchKeywordCheck(e)
            })

            return {
                versionOne,
                versionTwo,
            }
        }
    },

    methods : {
        /**
         * sorting 하는 함수입니다.
         *
         */
        sortOptionChange(e,selectOption,type) {
            const whatVersionData=!this.tabNumber?'versionOne':'versionTwo'
            this.tableBodyData[whatVersionData].sort((a, b) => {
                let prev ,next ;
                if(type ==="number"){//숫자일때 비교
                    prev = a[e]?a[e]:0;
                    next = b[e]?b[e]:0;
                }else { //문자일때 비교
                    prev = a[e]?a[e].toUpperCase():'';
                    next = b[e]?b[e].toUpperCase():'';
                }
                if (prev < next) {//클때
                    return -1 * selectOption.sortOrder;
                }else if(prev > next) {//작을때
                    return 1 * selectOption.sortOrder;
                }else {//같을때
                    return 0;
                }
            });
        },
        /**
         * 모델 추가 버튼을 클릭했을때 나오는 모달에서 작성완료 버튼 클릭시 동작합니다.
         * 선택한 Tab과 선택 안한 Tab 둘다 printerSeriesId로 데이터를 가져와 body에 넣습니다.
         * @param tabNumber
         * @param supportModel
         * @param printerSeriesId
         * @returns {Promise<void>}
         */
        async completeButtonClick(tabNumber,supportModel,supportedPrinter){
            const bodyData={
                ...supportedPrinter,
                supportModel
            }
            await this.updateRq(tabNumber,bodyData)
            await this.tableDataLoad(tabNumber)
        },
        /**
         * 테이블에있는 데이터들을 조회할때 동작하는 함수입니다.
         * V1일때는  1
         * V2일때는 2로 요청을 보내야됩니다.
         * @param reqTabNumber
         * @returns {Promise<void>}
         */
        async tableDataLoad(reqTabNumber) {
            this.isLoading = true;
            const req = await this.$request(`${PATH.MONITORING.SUPPORTED_PRINTER_SERIES}/${reqTabNumber + 1}`)
                .get()
                .catch((e) => {
                    this.isLoading = false;
                    alert('조회실패')
                })
                .enqueue()
            const whatVersionData=!reqTabNumber?'versionOne':'versionTwo'
            this.tableBodyData[whatVersionData] = req.data
            this.isLoading = false;
        },
        /**
         * 작성완료버튼 클릭시 동작하는 함수입니다.
         * @param reqTabNumber
         * @param bodyData
         * @returns {Promise<void>}
         */
        async updateRq(reqTabNumber,bodyData){
            if (!bodyData.supportModel || bodyData.supportModel === '') return alert(`V${reqTabNumber + 1} 지원모델이 없습니다.`)
            this.isLoading = true;
            await this.$request(`${PATH.MONITORING.SUPPORTED_PRINTER_SERIES_UPDATE}/${reqTabNumber + 1}`)
                .setObject({
                    ...bodyData
                })
                .catch((e) => {
                    this.isLoading = false;
                    alert('업데이트실패')
                })
                .enqueue()
            this.isLoading = false;
        }
    },
    /**
     * 처음에 V1 V2 둘다 데이터를 가져온다/
     */
    created() {
        this.tableDataLoad(this.tabNumber)
        this.tableDataLoad(this.tabNumber+1)
    }


}
</script>

<style scoped>
.loading_wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    background: rgba(0,0,0,0.5);
}

.loading {
    width: 8px;
    height: 8px;
    background: #aaaaaa;
    border-radius: 50%;
    animation: loading-cricle 1.5s infinite ease-in-out;
    display: inline-block;
    margin-right: 8px;
}

.loading:nth-child(2) {
    animation-delay: .5s;
}

.loading:nth-child(3) {
    animation-delay: 1s;
}
@keyframes loading-cricle {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }
    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}
/*Search Box 부분 font 랑 사이즈 조정 부분입니다*/
>>> .v-input__control .v-input__slot .v-text-field__slot input{
    font-size: 11px;
    padding: 0;
}

>>> .v-input__control .v-input__slot fieldset{
    height: 47px;
}

</style>
